<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="1" *ngIf="this.auth?.detailuser != undefined"></left-panel>
        <!-- <left-panel activeTab="1" *ngIf="this.auth?.detailuser != undefined"></left-panel>   -->
      </div>
    <div class="post-login-2-col-2">
        <div class="p-10">
            <div class="font-600 font-size-20px line-h-40 color-base-1700">
                {{"LoyaltyPoints" | translate }}
            </div>

             <div class="card-slider mt-10 p-10">
                    <owl-carousel-o [options]="carouselOptions" (translated)="selectCard($event)">
                        <ng-template carouselSlide *ngFor="let item of this.LoyaltyCards; let i = index">
                            <div class="loyalty-card mt-10">
                            <div class="text-box">
                                <div class="font-500 font-size-12px letter-spacing-1 color-base-100 text-uppercase" *ngIf="item?.isPrimaryCard==false">
                                   {{ "Mctitanium" |translate }}
                                </div>
                                <div class="font-500 font-size-12px letter-spacing-1 color-base-100 text-uppercase"  *ngIf="item?.isPrimaryCard==true">
                                    {{ "Mcforherpr" | translate}}
                                </div>
                                <div class="font-400 font-size-12px color-base-400">
                                    {{item?.maskedCardNumber}}
                                </div>
                                <div class="font-600 font-size-24px line-h-25 color-base-100 mt-15">
                                    {{item?.rewardsBalance}}
                                </div>
                                 <div class="font-400 font-size-12px color-base-100">
                                 {{"LoyaltyPoints"| translate}}
                                </div>
                                <div class="mt-15">
                                    <button class="btn-dft bg-1F1" (click)="Next123(item)" [disabled]="item?.rewardsBalance=='0'?true : false">
                                        {{"REDEEMNOW"| translate}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        </ng-template>
                    </owl-carousel-o>
             </div>

            <!-- Points Summary Cards -->
            <!-- Points summary (label left, icon + value right — matches mobile) -->
            <div class="points-summary-list mt-20">
                <div class="summary-card earned">
                    <div class="summary-label">{{"TotalPointsEarned" | translate}}</div>
                    <div class="summary-right">
                        <div class="summary-icon-wrap">
                            <ng-icon iconClass="icon-reward" width="22" height="22"></ng-icon>
                        </div>
                        <div class="summary-value">{{ (selectedLoyaltyCards?.pointsEarned | number:'1.0-0') || '—' }}</div>
                    </div>
                </div>
                <div class="summary-card redeemed">
                    <div class="summary-label">{{"TotalPointsRedeemed" | translate}}</div>
                    <div class="summary-right">
                        <div class="summary-icon-wrap">
                            <ng-icon iconClass="icon-reward" width="22" height="22"></ng-icon>
                        </div>
                        <div class="summary-value">{{ (selectedLoyaltyCards?.pointsRedeemed | number:'1.0-0') || '—' }}</div>
                    </div>
                </div>
                <div class="summary-card expiring-soon" *ngIf="selectedLoyaltyCards?.pointsExpiringInNextMonth > 0">
                    <div class="summary-label">{{"PointsExpiringNextMonth" | translate}}</div>
                    <div class="summary-right">
                        <div class="summary-icon-wrap">
                            <ng-icon iconClass="icon-reward" width="22" height="22"></ng-icon>
                        </div>
                        <div class="summary-value">{{ (selectedLoyaltyCards?.pointsExpiringInNextMonth | number:'1.0-0') || '—' }}</div>
                    </div>
                </div>
                <div class="summary-card expiring-3month" *ngIf="selectedLoyaltyCards?.pointsExpiringInNextThreeMonths > 0">
                    <div class="summary-label">{{"PointsExpiringNext3Month" | translate}}</div>
                    <div class="summary-right">
                        <div class="summary-icon-wrap">
                            <ng-icon iconClass="icon-reward" width="22" height="22"></ng-icon>
                        </div>
                        <div class="summary-value">{{ (selectedLoyaltyCards?.pointsExpiringInNextThreeMonths | number:'1.0-0') || '—' }}</div>
                    </div>
                </div>
            </div>

            <!-- Points Calculator (hidden for now)
            <div class="points-calculator-card mt-20">
                <div class="calc-header">
                    <ng-icon iconClass="icon-filter-big" width="20" height="20"></ng-icon>
                    <span class="font-600 font-size-14px">{{"PointsCalculator" | translate}}</span>
                </div>
                <div class="calc-inputs mt-15">
                    <div class="calc-field">
                        <label class="font-400 font-size-11px color-base-600">{{"SelectCard" | translate}}</label>
                        <select class="form-control" [(ngModel)]="selectedCalcCardInternalId" (ngModelChange)="onCalcCardChange($event)">
                            <option value="">-- Select Card --</option>
                            <option *ngFor="let card of LoyaltyCards" [value]="card.cardInternalId">{{ card.refrenceTrans }} - {{ card.rewardsBalance }} pts</option>
                        </select>
                    </div>
                    <div class="calc-field">
                        <label class="font-400 font-size-11px color-base-600">{{"LocalSpend" | translate}}</label>
                        <div class="input-wrap">
                            <span class="currency-prefix">BHD</span>
                            <input type="number" [(ngModel)]="calcLocalSpend" (ngModelChange)="calculatePoints()" placeholder="0.000" min="0" step="0.001">
                        </div>
                    </div>
                    <div class="calc-field">
                        <label class="font-400 font-size-11px color-base-600">{{"InternationalSpend" | translate}}</label>
                        <div class="input-wrap">
                            <span class="currency-prefix">BHD</span>
                            <input type="number" [(ngModel)]="calcIntlSpend" (ngModelChange)="calculatePoints()" placeholder="0.000" min="0" step="0.001">
                        </div>
                    </div>
                    <div class="calc-field">
                        <label class="font-400 font-size-11px color-base-600">{{"GovPetrolStation" | translate}}</label>
                        <div class="input-wrap">
                            <span class="currency-prefix">BHD</span>
                            <input type="number" [(ngModel)]="calcGovPetrol" (ngModelChange)="calculatePoints()" placeholder="0.000" min="0" step="0.001">
                        </div>
                    </div>
                    <div class="calc-field">
                        <label class="font-400 font-size-11px color-base-600">{{"EURGBPPhysical" | translate}}</label>
                        <div class="input-wrap">
                            <span class="currency-prefix">BHD</span>
                            <input type="number" [(ngModel)]="calcEurGbp" (ngModelChange)="calculatePoints()" placeholder="0.000" min="0" step="0.001">
                        </div>
                    </div>
                </div>
                <button class="btn-dft mt-15 w-100" (click)="calculatePoints()">{{ "Calculate" | translate }}</button>
                <div class="calc-results mt-15" *ngIf="calcResult">
                    <div class="result-row">
                        <span class="font-400 font-size-11px color-base-600">{{"LocalSpend" | translate}}</span>
                        <span class="font-600 font-size-13px">{{calcResult.localSpend || 0}} pts</span>
                    </div>
                    <div class="result-row">
                        <span class="font-400 font-size-11px color-base-600">{{"InternationalSpend" | translate}}</span>
                        <span class="font-600 font-size-13px">{{calcResult.internationalSpend || 0}} pts</span>
                    </div>
                    <div class="result-row">
                        <span class="font-400 font-size-11px color-base-600">{{"GovPetrolStation" | translate}}</span>
                        <span class="font-600 font-size-13px">{{calcResult.govPetrolStation || 0}} pts</span>
                    </div>
                    <div class="result-row">
                        <span class="font-400 font-size-11px color-base-600">{{"EURGBPPhysical" | translate}}</span>
                        <span class="font-600 font-size-13px">{{calcResult.euRandGBP || 0}} pts</span>
                    </div>
                    <div class="result-total">
                        <span class="font-600 font-size-14px">{{"TotalPoints" | translate}}</span>
                        <span class="font-700 font-size-18px color-primary">{{calcResult.totalPoints || 0}}</span>
                    </div>
                </div>
            </div>
            -->
        </div>
    </div>
    <div class="post-login-2-col-3">
        <div class="font-600 font-size-20px line-h-40 color-base-1700 mt-8">
            {{"ImtiazTitaniumCard" | translate }}
        </div>
        <div>
            <div>
                <grid-row class="justify-content-between mt-20">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1200 text-uppercase letter-spacing-1">
                            {{"PointsHistory" | translate }}
                        </div>
                    </grid-col>
                     <!-- <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-18 color-base-2200 letter-spacing-03 link-u">
                            {{"ViewAll" | translate}}
                        </div>
                    </grid-col> -->
                    <grid-col col="auto">
                        <span class="position-relative">
                            <ng-icon iconClass="icon-filter-transaction link" width="24" height="24" (click)="showModal(1)" ></ng-icon>
                            <span class="icon-filter-transaction-active" *ngIf =" this.selectedMonth != undefined && selectedMonth.length > 0" ></span>
                          </span>
                    </grid-col>

                </grid-row>

                <!-- <grid-row class="mt-30">
                    <grid-col col="auto">
                        <div class="bg-color-base-3200 pr-16 pl-16 br-40">
                            <span class="font-600 font-size-12px line-h-40 color-base-800 text-uppercase">
                                September 2023
                            </span>
                            <ng-icon iconClass="icon-close-10px v-align-middle ml-10 link" width="10" height="10"></ng-icon>
                        </div>
                    </grid-col>
                </grid-row> -->

                    <!-- old chunk comment by Raheel -->
                <!-- <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-20 p-16" *ngFor="let Months of this.uniqueMonths let i=index">
                    <span class="font-400 font-size-14px color-base-1500">{{Months | date : "dd MMM yyyy"}}</span>
                    <grid-row class="justify-content-between mb-20 mt-5" *ngFor="let item of this.groupedData[Months]">
                        <grid-col col="auto">
                         <div class="font-400 font-size-14px  color-base-1300">
                            {{item?.activityType}}
                         </div>
                         <div class="font-400 font-size-12px  color-base-2000" *ngIf="item?.maskedCardNumber!==''">
                           {{item?.maskedCardNumber}}
                         </div>
                        </grid-col>
                        <grid-col col="auto">
                        <div class="font-size-14px font-600 text-align-right" [ngClass]="this.checkamount(item?.points)=='negative'? 'color-error' :'color-success'">
                         <span *ngIf="item?.points?.split('-')[0]">
                             {{item?.points}}
                        </span> 
                         <span  *ngIf="!item?.points?.split('-')[0]">
                           {{item?.points?.split('-')[1]}} Pts
                         </span>
                        </div>
                        <div class="font-400 font-size-12px  color-base-600" *ngIf="item?.expiryDate!==''">
                            EXP: {{item?.expiryDate | date : "dd MM yyyy" }}
                         </div>
                        </grid-col>
                    </grid-row> 
                </div> -->

                <div *ngFor="let Months of this.uniqueMonths let i=index">
                    <div class="font-600 font-size-12px line-h-40 color-base-800 text-uppercase mt-16" *ngIf="Months && getFilteredItems(this.groupedData[Months])?.length > 0">
                        {{Months | date : "dd MMM yyyy"}}
                    </div>
                    <div class="bg-base-100 box-shadow border border-color-900 br-16 pl-15 pr-15">
                        <grid-row class="justify-content-between align-item-top link mt-15 mb-15"
                            *ngFor="let item of getFilteredItems(this.groupedData[Months])">
                            <grid-col col="auto">
                                <grid-row class="align-item-center">
                                    <grid-col col="auto">
                                        <div class="partner-icon-sm">
                                            <ng-icon [iconClass]="getHistoryPartnerIcon(item)" style="width: 26px; height: 26px; filter: brightness(0) invert(1);"></ng-icon>
                                        </div>
                                    </grid-col>
                                    <grid-col col="auto" class="ml-10">
                                        <div class="font-400 font-size-14px line-h-20 color-base-1300">
                                            {{item?.activityType}}
                                        </div>
                                        <div class="font-400 font-size-12px line-h-18 color-base-1900 letter-spacing-1 mt-2">
                                           <span *ngIf="!item?.referenceNumber || item?.maskedCardNumber === ''"> Ref Number:  {{item?.referenceNumber}}</span>
                                        </div>
                                        <div class="font-400 font-size-11px line-h-16 color-base-600 mt-2" *ngIf="item?.partnerCode">
                                            Ref: {{item?.partnerCode}}
                                        </div>
                                    </grid-col>
                                </grid-row>
                            </grid-col>
                            <grid-col col="auto" class="text-align-right">
                                <div class="font-600 font-size-14px line-h-20" [ngClass]="this.checkamount(item?.points)=='negative'? 'color-black' :'color-success'">
                                    <strong class="font-600" *ngIf="item?.points?.split('-')[0]">{{item?.points}} Pts</strong>
                                    <strong class="font-600"  *ngIf="!item?.points?.split('-')[0]">{{item?.points?.split('-')[1]}} Pts</strong>
                                </div>
                                <div class="font-400 font-size-12px line-h-12 color-base-600 mt-7" *ngIf="item?.expiryDate!==''">
                                    EXP: {{item?.expiryDate | date : "dd MM yyyy" }}
                                </div>
                                <div class="mt-5" *ngIf="getStatusBadgeClass(item?.status)">
                                    <span class="status-badge" [ngClass]="getStatusBadgeClass(item?.status)">
                                        {{ getStatusLabel(item?.status) | translate }}
                                    </span>
                                </div>
                            </grid-col>
                        </grid-row>
                    </div>
                </div>

                

                <!-- Empty state when filter returns no results -->
                <div *ngIf="selectedCategory !== 'all' && !hasFilteredItems()" class="empty-filter-state mt-40">
                    <div class="empty-icon-wrap">
                        <ng-icon iconClass="icon-filter-big" width="48" height="48"></ng-icon>
                    </div>
                    <div class="empty-title font-500 font-size-16px color-base-700 mt-20">
                        No transactions found
                    </div>
                    <div class="empty-desc font-400 font-size-13px color-base-500 mt-8">
                        You don't have any {{getSelectedCategoryLabel()}} transactions yet
                    </div>
                </div>

                <div *ngIf="PointHistory?.length==0 && selectedCategory === 'all'" class="mt-50">
                    <grid-row class="justify-content-center align-item-center h-100 pt-50">
                        <grid-col col="4">
                            <div class="text-align-center mt-50">
                                <ng-icon iconClass="icon-loan-dashboard-big" width="120" height="120"></ng-icon>
                            </div>
                            <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-10">
                                {{"NoTransaction" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <!-- <grid-row class="justify-content-center align-item-center h-100" *ngIf="this.cardDetail?.length==0">
            <grid-col col="5">
                <div class="text-align-center">
                    <ng-icon iconClass="icon-creditcard-not-available" width="307" height="230"></ng-icon>
                </div>
                <div class="font-400 font-size-20px line-h-25 color-base-700 text-align-center mt-30">
                    {{"NoCreditCardAvailable" | translate }}
                </div>
                <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-5">
                    {{"YouDontHaveCreditCardAccounts" | translate }}
                </div>
            </grid-col>
        </grid-row> -->

    </div>
</div>

<modal modalID="1"  modalClass="height-auto-flex" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="NEXT"
[whiteButtonStatus]="true" whiteButtonText="CANCEL" modalHeading="FILTERBYMonth" (doneButton)="FilterDone()">
<app-month-picker (returnSelectedMonth)="test($event)"></app-month-picker>
</modal>

   <!-- Points Redemption -->
   <modal modalClass="height-auto-flex" modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="NEXT" [showClose]="false"
   [whiteButtonStatus]="true" whiteButtonText="CANCEL" [modalDoneButtonDisabled]="this.Redmp" (doneButton)="loyaltyPointsRadeem()" (whiteButton)="cancel()" modalHeading="PointsRedemption">
   <div class="font-500 font-size-14px line-h-22 letter-spacing-1 coloe-base-1300">
       {{"PreferredTypeedemption" | translate}}
   </div>
   <div class="custom-radio-3 mt-30" >
       <input type="radio" id="radio-1" name="radioGroup2" (change)="onRedemptionChange($event,1)">
       <label for="radio-1">
           <grid-row class="col-space-min align-item-center">
               <grid-col col="auto">
                   <div class="font-500 font-size-14px line-h-20">
                       <ng-icon iconClass="icon-cash-back" width="24" height="24"></ng-icon>
                   </div>
               </grid-col>
               <grid-col col="auto">
                   <div class="font-600 font-size-14px line-h-22 letter-spacing-03 color-base-1500">
                       {{"cashback" | translate}}
                   </div>
               </grid-col>
           </grid-row>
       </label>
   </div>
   <div class="custom-radio-3 mt-16" >
       <input type="radio" id="radio-2" name="radioGroup2"  (change)="onRedemptionChange($event,2)">
       <label for="radio-2">
           <grid-row class="col-space-min align-item-center">
               <grid-col col="auto">
                   <div class="font-500 font-size-14px line-h-20">
                       <ng-icon iconClass="icon-gulf-air" width="32" height="32"></ng-icon>
                   </div>
               </grid-col>
               <grid-col col="auto">
                   <div class="font-600 font-size-14px line-h-22 letter-spacing-03 color-base-1500">
                       {{"TransferGulfAir" | translate}}
                   </div>
               </grid-col>
           </grid-row>
       </label>
   </div>
   <div class="custom-radio-3 mt-16" >
       <input type="radio" id="radio-3" name="radioGroup2"  (change)="onRedemptionChange($event,3)">
       <label for="radio-3">
           <grid-row class="col-space-min align-item-center">
               <grid-col col="auto">
                   <div class="font-500 font-size-14px line-h-20">
                       <ng-icon iconClass="icon-shukran" width="32" height="32"></ng-icon>
                   </div>
               </grid-col>
               <grid-col col="auto">
                   <div class="font-600 font-size-14px line-h-22 letter-spacing-03 color-base-1500">
                       {{"Shukran" | translate}}
                   </div>
               </grid-col>
           </grid-row>
       </label>
   </div>
</modal>
